var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "fromUnityModal",
      attrs: {
        id: "unity-material",
        centered: "",
        "hide-footer": "",
        size: "lg",
        title: "Agregar desde Unidad",
        "no-close-on-backdrop": "",
        "no-close-on-esc": ""
      },
      on: {
        close: function($event) {
          return _vm.onModalClose()
        }
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "vx-card",
        { staticClass: "fill", attrs: { "title-color": "primary" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [
                  _vm._v("Buscar por coincidencias Nombre Material")
                ]),
                _c(
                  "b-input-group",
                  [
                    _c(
                      "b-input-group-prepend",
                      { attrs: { "is-text": "" } },
                      [_c("b-icon", { attrs: { icon: "search" } })],
                      1
                    ),
                    _c("b-form-input", {
                      model: {
                        value: _vm.textSearch,
                        callback: function($$v) {
                          _vm.textSearch = $$v
                        },
                        expression: "textSearch"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row mt-1" }, [
            _c("div", { staticClass: "col-5" }, [
              _c("label", [_vm._v("Categoría")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.categoryMaterial,
                      expression: "categoryMaterial"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "select" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.categoryMaterial = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { selected: "", value: "" } }),
                  _vm._l(_vm.listCategorys, function(option) {
                    return _c(
                      "option",
                      {
                        key: option.categoryId,
                        domProps: {
                          value: {
                            value: option.categoryId,
                            text: option.categoryName
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(option.categoryName) + " ")]
                    )
                  })
                ],
                2
              )
            ]),
            _c("div", { staticClass: "col-5" }, [
              _c("label", [_vm._v("Marca:")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.brandMaterial,
                      expression: "brandMaterial"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "select" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.brandMaterial = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { selected: "", value: "" } }),
                  _vm._l(_vm.listBrands, function(option) {
                    return _c(
                      "option",
                      {
                        key: option.brandId,
                        domProps: {
                          value: {
                            value: option.brandId,
                            text: option.brandName
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(option.brandName) + " ")]
                    )
                  })
                ],
                2
              )
            ]),
            _c(
              "div",
              { staticClass: "col-2 align-self-end" },
              [
                _c(
                  "vs-chip",
                  {
                    staticStyle: { cursor: "pointer" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.searchListMaterial()
                      }
                    }
                  },
                  [
                    _c("vs-avatar", {
                      attrs: { icon: "search", color: "primary" }
                    }),
                    _c("strong", [_vm._v("Buscar")])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("div", { staticClass: "row mt-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("b-table", {
              ref: "selectableTable",
              staticClass: "h-100",
              attrs: {
                fields: _vm.fieldMaterial,
                items: _vm.listMaterials,
                "tbody-tr-class": _vm.rowClass,
                hover: "",
                "select-mode": _vm.onTableSelected,
                selectable: "",
                "sticky-header": ""
              },
              on: { "row-selected": _vm.onRowSelected },
              scopedSlots: _vm._u([
                {
                  key: "cell(selected)",
                  fn: function(ref) {
                    var rowSelected = ref.rowSelected
                    return [
                      rowSelected
                        ? [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("✓")
                            ])
                          ]
                        : [_c("span", { attrs: { "aria-hidden": "true" } })]
                    ]
                  }
                },
                {
                  key: "cell(categoryMaterial)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(row.item.categoryMaterial.descripcion) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "cell(brandMaterial)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        " " + _vm._s(row.item.brandMaterial.descripcion) + " "
                      )
                    ]
                  }
                },
                {
                  key: "cell(priceMaterial)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              parseInt(row.item.priceMaterial)
                            )
                          ) +
                          " "
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.enableActions() && this.whoCall === ""
            ? [
                _c(
                  "span",
                  { staticClass: "col-auto", attrs: { "aria-hidden": "true" } },
                  [_vm._v(_vm._s(_vm.selected[0].nameMaterial))]
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        type: "number",
                        placeholder: "Ingresa cantidad",
                        size: "sm"
                      },
                      model: {
                        value: _vm.qtyMaterial,
                        callback: function($$v) {
                          _vm.qtyMaterial = $$v
                        },
                        expression: "qtyMaterial"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "d-flex align-items-end" },
        [
          _c("MaterialPagination", {
            on: { change: _vm.onPageChange },
            model: {
              value: _vm.actualPage,
              callback: function($$v) {
                _vm.actualPage = $$v
              },
              expression: "actualPage"
            }
          })
        ],
        1
      ),
      _c("hr"),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn pull-right ml-3",
                attrs: { size: "sm" },
                on: { click: _vm.onModalClose }
              },
              [_vm._v(" Cancelar ")]
            ),
            _vm.whoCall === ""
              ? _c(
                  "b-button",
                  {
                    staticClass: "btn btn-primary pull-right ml-3",
                    attrs: { disabled: !_vm.enableActions(), size: "sm" },
                    on: { click: _vm.addMaterialEntity }
                  },
                  [_vm._v(" Guardar ")]
                )
              : _vm._e(),
            _vm.whoCall === "catalog"
              ? _c(
                  "b-button",
                  {
                    staticClass: "btn btn-primary pull-right ml-3",
                    attrs: { disabled: !_vm.enableActions(), size: "sm" },
                    on: { click: _vm.addMaterial }
                  },
                  [_vm._v(" Guardar ")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }